export default {
  googleAuth: {},
};
